import { useCallback, useState } from 'react';
import cls from 'clsx';
import { Left, Right } from '@linktivity/link-icons';
import { Menu } from '@linktivity/link-ui';
import styles from './layoutSidebar.module.css';

interface LayoutSidebarProps {
  children?: React.ReactNode;
}

const LayoutSidebar: React.FC<LayoutSidebarProps> = ({ children }) => {
  const [collapsed, setCollapsed] = useState(false);

  const toggleCollapsed = useCallback(() => {
    setCollapsed(prev => !prev);
  }, []);

  return (
    <aside className={cls(styles.sidebar, { [styles.collapsed]: collapsed })}>
      <button
        type="button"
        className={styles.toggle}
        onClick={toggleCollapsed}
        aria-expanded={!collapsed}
      >
        {collapsed ? (
          <Right width={16} height={16} />
        ) : (
          <Left width={16} height={16} />
        )}
      </button>
      <div className={styles.nav}>
        <div className={styles.inner}>
          <Menu className={styles.menu} accordion>
            {children}
          </Menu>
        </div>
      </div>
    </aside>
  );
};

export default LayoutSidebar;
